module.exports = "/shared/img/arrows.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/arrows.png
// module id = 23
// module chunks = 13